export const BREADCRUMB_TITLES_KEY = 'breadcrumb_titles';
export const BREADCRUMB_UPDATE_EVENT = 'breadcrumb_titles_updated';

export const getBreadcrumbTitle = (id: string): string | null => {
  try {
    const stored = localStorage.getItem(BREADCRUMB_TITLES_KEY);
    if (stored) {
      const titles = JSON.parse(stored);
      return titles[id]?.title || null;
    }
  } catch (e) {
  }
  return null;
};
